import { getContext } from '@fiverr-private/fiverr_context';
import { AgencySeller } from '../../types';
import { useAgencySellerData } from '../useAgencySellerData';

export const useIsCurrentUser = () => {
    const { sellerId } = useAgencySellerData(selectSellerSlice);
    const { userId } = getContext();

    return userId?.toString() === sellerId?.toString();
};

function selectSellerSlice(seller: AgencySeller) {
    return {
        sellerId: seller.user.id,
    };
}
